createjs.Tween.prototype.toPromise = function () {
    return new Promise(resolve => {
        this.call(resolve);
    });
}

export default class TweenUtil {
    static async tillTweenCompleted(tween) {
        return new Promise(resolve => {
            tween.call(resolve);
        });
    }
}